import { render, staticRenderFns } from "./terms_preview.vue?vue&type=template&id=4e516c9f&scoped=true"
import script from "./terms_preview.vue?vue&type=script&lang=js"
export * from "./terms_preview.vue?vue&type=script&lang=js"
import style0 from "./terms_preview.vue?vue&type=style&index=0&id=4e516c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e516c9f",
  null
  
)

export default component.exports